import React from 'react';
import PropTypes from 'prop-types';
import {InfoCircleFilled} from '@ant-design/icons';
import {StyledMissingInfo, StyledMissingInfoDescription} from './StyledMissingInfo';

const MissingInfo = ({
  description,
  ...rest
}) => {
  return (
    <StyledMissingInfo
      size='small'
      {...rest}
    >
      <InfoCircleFilled />
      <StyledMissingInfoDescription>
        {description}
      </StyledMissingInfoDescription>
    </StyledMissingInfo>
  );
}

MissingInfo.propTypes = {
  description: PropTypes.string,
}

export default MissingInfo;

